<script setup lang="ts">
import { computed } from 'vue'
import { itemScopeAttributes, useModelStrings, type ItemTemplateProps } from '@jantm/model-core'
import type {Certificate} from "@/types/Wiser/certificate.ts";
import {useRouter} from "vue-router";

/**
 * Custom item rendering for Certificate.
 *
 * Narrowing `entity` to `Certificate` is the whole point of a per-model template: the
 * props contract stays the one model-core passes, but inside this file the
 * entity is fully typed.
 */
const props = withDefaults(defineProps<ItemTemplateProps<Certificate>>(), { headingLevel: 3 })

const { t, locale } = useModelStrings(() => props.definition)

const scope = computed(() => itemScopeAttributes(props.definition))
const heading = computed(() => `h${props.headingLevel}` as const)
const router = useRouter()
const entityId = computed(() => props.entity?.id ?? 0)
const gotoDetail = function() {
  router.push({name: 'wiser-certificate', params: {id: entityId.value}})
}
</script>

<template>
  <article
    class="wiser-item certificate-item"
    v-bind="scope"
    @click="gotoDetail"
  >
    <component
      :is="heading"
      class="wiser-item__title certificate-item__title"
    >
      <span>{{ entity.id }}</span>
    </component>
    <span>{{ entity.cursusnaam }}</span>
    <span>{{ entity.cursuscode }}</span>
    <span>{{ `${entity.cursist_aanhef ?? ''} ${entity.cursist_voorletters ?? ''} (${entity.cursist_voornaam ?? ''}) ${entity.cursist_tussenvoegsel ?? ''} ${entity.cursist_achternaam ?? ''}`}}</span>
    <span>{{ entity.examendatum_kort }}</span>
  </article>
</template>
